import React from 'react';
import {connect} from 'react-redux';
import Loader from 'react-loader';

import {browserHistory} from 'react-router';
import {articleIndexRoute} from '../../../constants/public-routes';
import {getIdFromRelation} from "../../app/selectors";

class ElementRedirect extends React.Component {
  constructor(props) {
    super(props);

    this.redirectIfPossible = this.redirectIfPossible.bind(this);
    this.redirectIfPossible(props);
  }

  componentWillMount() {
    this.redirectIfPossible(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.redirectIfPossible(nextProps);
  }

  redirectIfPossible(props) {
    let {element, elementId, language, structure} = props;
    if (element && element.item && element.item.id === elementId && structure && structure.item && structure.item.id) {
      let structureId = structure.item.id;
      let articleId = getIdFromRelation(element.item, 'article');
      if (articleId !== -1) {
        browserHistory.push(articleIndexRoute(language, structureId, articleId));
      }
    }
  }

  render() {
    return (
      <div>
        <p>Redirecting...</p>
        <Loader loaded={false}/>
      </div>
    );
  }
}

ElementRedirect.propTypes = {
  language: React.PropTypes.string,
  elementId: React.PropTypes.string,
  element: React.PropTypes.object,
  structure: React.PropTypes.object
};

function mapStateToProps(state, ownProps) {
  const {lang, elementId} = ownProps.params;
  let {element, structure} = state;


  return {
    language: lang,
    elementId,
    element,
    structure
  };
}


export default connect(mapStateToProps)(ElementRedirect);



/** WEBPACK FOOTER **
 ** ./src/modules/elements/components/ElementRedirect.js
 **/